// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"FF0tqRt","gradient":"BYxJFlI","skeleton-loader--pill":"TCkcPLh"};